// The Space hint beside "Next thing" (U3): the highlighted step runs on Space; a send or a
// calendar write only arms, so the hint says a confirm follows.
import type { CardAction } from "@shared/core";
import { Kbd } from "@web/ui/Kbd";
import { needsConfirmation } from "../actions";
import { recommendedAction } from "../recommended";

export function RecommendedKey({ actions }: { actions: readonly CardAction[] }) {
  const action = recommendedAction(actions);
  if (!action) return null;
  return (
    <span
      data-testid="recommended-key"
      className="ml-2 hidden items-center gap-1 align-middle text-xs font-normal text-muted sm:inline-flex"
    >
      <Kbd>Space</Kbd>
      {needsConfirmation(action) ? "then confirm" : null}
    </span>
  );
}
